module.exports = __webpack_public_path__ + "static/tchc-logo-b1fbf17f10ab9258f7413c3bd3eb2a0d.png";